import { render, staticRenderFns } from "./ChildInvoicesTable.vue?vue&type=template&id=ff7dd59c&scoped=true&"
import script from "./ChildInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./ChildInvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./ChildInvoicesTable.vue?vue&type=style&index=0&id=ff7dd59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7dd59c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VChip,VContainer,VDataTable,VFlex,VLayout,VSpacer})
